require('./assets/vendor/bootstrap-5.1.1/bootstrap.min.css')
require('./assets/vendor/google-open-sans/font.css')
require('./assets/vendor/google-handlee/font.css')
require('swiper/swiper-bundle.min.css')
require('shariff/dist/shariff.min.css')
require('./assets/styles/app/app.less')

require('jquery')
require('swiper/swiper-bundle.min.js')
require('shariff')
require('./assets/js/custom.js')


require('air-datepicker/air-datepicker.css');
require('air-datepicker/air-datepicker');
require('air-datepicker/locale/de');